import { Injectable } from "@angular/core";
import * as moment from "moment";

@Injectable()
export class GridHeaderService {
  public getDaysOfMonth(year, month, fromDate, toDate) {
    let result = [];
    let days = ["D", "L", "M", "M", "J", "V", "S"];
    let totalDays = moment()
      .set("year", year)
      .set("month", month)
      .daysInMonth();
    let limitDay = 1;

    if (moment(fromDate).month() === month) {
      limitDay = moment(fromDate).date();
    }
    if (moment(toDate).month() === month) {
      totalDays = moment(toDate).date();
    }

    for (let day = limitDay; day <= totalDays; day++) {
      let dayDate = new Date(year, month, day);
      let strDay = days[dayDate.getDay()];
      let dayNumber = day < 10 ? "0" + day : day;
      result.push(strDay + dayNumber);
    }
    return result;
  }

  public getWeeksOfYear(totalWeek, firstWeek, firstMonth, year) {
    let result = [];

    if ((firstWeek === 52 || firstWeek === 53) && firstMonth === 0) {
      // If first week start with 52/53 we push and start at 1 after
      result.push(`S${firstWeek}`);
      firstWeek = 1;
      totalWeek -= 1;
    }

    for (let week = firstWeek; week < firstWeek + totalWeek; week++) {
      const weekNumber =
        week < 10
          ? week === 0
            ? moment(moment(year.toString()), "DD-MM-YYYY").week()
            : week
          : week === 53
          ? moment(moment(year.toString()).add(52, "w"), "DD-MM-YYYY").week()
          : week;

      result.push(weekNumber >= 10 ? "S" + weekNumber : "S0" + weekNumber);
    }

    return result;
  }

  public getMonthHeader(fromDate, toDate, totalWeeks) {
    let headerMonth = [];
    let weekStart = moment(fromDate).startOf("day");
    const endDate = moment(toDate).endOf("day");

    // The grid itself is built from seven-day periods beginning on
    // broadcasted_from. Group the month header using those exact same
    // periods: for a start on 15 February, S07-S08 are in February and
    // S09 starts in March. The last displayed period can extend past the
    // selected end date; it remains attached to the month of that end date.
    for (let weekIndex = 0; weekIndex < totalWeeks; weekIndex++) {
      const monthDate = weekStart.isAfter(endDate, "day") ? endDate : weekStart;
      const monthKey = monthDate.format("YYYY-MM");
      const lastMonth = headerMonth[headerMonth.length - 1];

      if (lastMonth && lastMonth.key === monthKey) {
        lastMonth.value += 1;
      } else {
        headerMonth.push({
          key: monthKey,
          name: monthDate.format("MMMM"),
          value: 1,
        });
      }

      weekStart.add(1, "week");
    }

    return headerMonth.map(({ name, value }) => ({ name, value }));
  }
}
